import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6" }
const _hoisted_2 = { class: "grid md:grid-cols-4 gap-4" }
const _hoisted_3 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_4 = { class: "overflow-x-auto" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "divide-y divide-gray-200" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  colspan: "6",
  class: "px-6 py-16 text-center"
}
const _hoisted_9 = { class: "px-6 py-4" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_11 = { class: "text-xs text-gray-400 font-mono" }
const _hoisted_12 = { class: "px-6 py-4" }
const _hoisted_13 = { class: "text-sm text-gray-900" }
const _hoisted_14 = { class: "text-xs text-gray-500" }
const _hoisted_15 = { class: "px-6 py-4 text-sm text-gray-600" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_18 = { class: "px-6 py-4 text-sm text-gray-900" }
const _hoisted_19 = { class: "px-6 py-4" }
const _hoisted_20 = { class: "px-6 py-4 text-sm text-gray-600" }
const _hoisted_21 = {
  key: 0,
  class: "px-6 py-4 border-t border-gray-200 flex items-center justify-between"
}
const _hoisted_22 = { class: "text-sm text-gray-600" }
const _hoisted_23 = { class: "flex items-center gap-2" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "text-sm text-gray-600" }
const _hoisted_26 = ["disabled"]

import { ref, onMounted } from 'vue'
import { Icon } from '@iconify/vue'
import { apiFor, isEnvironmentUnauthorized } from '../services/api'
import EnvironmentUnavailable from '../components/EnvironmentUnavailable.vue'
import { useModeStore } from '../store/mode'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrdersView',
  setup(__props) {

const modeStore = useModeStore()

const deliveries = ref<any[]>([])
const loading = ref(true)
const envUnavailable = ref(false)
const pagination = ref({ total: 0, page: 1, limit: 20, totalPages: 1 })

const filters = ref({ status: '', from: '', to: '', search: '' })

onMounted(load)

async function load() {
  loading.value = true
  try {
    const params: Record<string, any> = {
      page: pagination.value.page,
      limit: pagination.value.limit,
    }
    if (filters.value.status) params.status = filters.value.status
    if (filters.value.from) params.from = filters.value.from
    if (filters.value.to) params.to = new Date(`${filters.value.to}T23:59:59`).toISOString()
    if (filters.value.search) params.search = filters.value.search

    const { data } = await apiFor(modeStore.mode).get('/partner-portal/deliveries', { params })
    deliveries.value = data.deliveries || []
    pagination.value = data.pagination || pagination.value
  } catch (err) {
    envUnavailable.value = isEnvironmentUnauthorized(err)
    console.error('Erreur chargement livraisons:', err)
    deliveries.value = []
  } finally {
    loading.value = false
  }
}

function reload() {
  pagination.value.page = 1
  load()
}

function changePage(page: number) {
  if (page < 1 || page > pagination.value.totalPages) return
  pagination.value.page = page
  load()
}

function statusLabel(status: string): string {
  return (
    {
      CREATED: 'Créée',
      ASSIGNED: 'Assignée',
      PICKED_UP: 'En cours',
      DELIVERED: 'Livrée',
      CANCELED: 'Annulée',
      INCIDENT: 'Incident',
    } as Record<string, string>
  )[status] || status
}

function statusClass(status: string): string {
  return (
    {
      CREATED: 'bg-gray-100 text-gray-800',
      ASSIGNED: 'bg-blue-100 text-blue-800',
      PICKED_UP: 'bg-[#8C0004] bg-opacity-10 text-[#8C0004]',
      DELIVERED: 'bg-green-100 text-green-800',
      CANCELED: 'bg-gray-200 text-gray-600',
      INCIDENT: 'bg-orange-100 text-orange-800',
    } as Record<string, string>
  )[status] || 'bg-gray-100 text-gray-800'
}

function formatDate(value: string): string {
  if (!value) return '—'
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (envUnavailable.value)
      ? (_openBlock(), _createBlock(EnvironmentUnavailable, {
          key: 0,
          class: "mb-6"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Statut", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.status) = $event)),
            onChange: reload,
            class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
          }, [...(_cache[6] || (_cache[6] = [
            _createStaticVNode("<option value=\"\">Tous les statuts</option><option value=\"CREATED\">Créée</option><option value=\"ASSIGNED\">Assignée</option><option value=\"PICKED_UP\">En cours</option><option value=\"DELIVERED\">Livrée</option><option value=\"CANCELED\">Annulée</option><option value=\"INCIDENT\">Incident</option>", 7)
          ]))], 544), [
            [_vModelSelect, filters.value.status]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Du", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.from) = $event)),
            onChange: reload,
            type: "date",
            class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
          }, null, 544), [
            [_vModelText, filters.value.from]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Au", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.to) = $event)),
            onChange: reload,
            type: "date",
            class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
          }, null, 544), [
            [_vModelText, filters.value.to]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Rechercher", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.search) = $event)),
            onKeyup: _withKeys(reload, ["enter"]),
            placeholder: "Référence, destinataire...",
            class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
          }, null, 544), [
            [_vModelText, filters.value.search]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _cache[14] || (_cache[14] = _createElementVNode("thead", { class: "bg-gray-50 border-b border-gray-200" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Référence"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Destinataire"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Livreur"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Montant"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Statut"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Créée le")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_6, [
            (loading.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
                  return _createElementVNode("tr", {
                    key: `skel-${i}`,
                    class: "animate-pulse"
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("td", {
                      colspan: "6",
                      class: "px-6 py-4"
                    }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-100 rounded w-full" })
                    ], -1)
                  ]))])
                }), 64))
              : (deliveries.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_unref(Icon), {
                        icon: "solar:box-bold",
                        class: "w-10 h-10 text-gray-300 mx-auto mb-3"
                      }),
                      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-gray-500" }, "Aucune livraison dans cet environnement.", -1)),
                      _createVNode(_component_router_link, {
                        to: "/docs",
                        class: "text-sm text-[#8C0004] hover:underline"
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode(" Créer une livraison depuis la documentation ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(deliveries.value, (d) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: d.id,
                      class: "hover:bg-gray-50 transition-colors"
                    }, [
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(d.externalRef || '—'), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(d.id.slice(0, 8)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(d.recipientName || '—'), 1),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(d.recipientPhone || ''), 1)
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        (d.courier)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(d.courier.firstName), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, "Non assigné"))
                      ]),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(d.amount != null ? `${Math.round(d.amount)} FCFA` : '—'), 1),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['px-3 py-1 rounded-full text-xs font-semibold', statusClass(d.status)])
                        }, _toDisplayString(statusLabel(d.status)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(formatDate(d.createdAt)), 1)
                    ]))
                  }), 128))
          ])
        ])
      ]),
      (pagination.value.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("p", _hoisted_22, _toDisplayString(deliveries.value.length) + " sur " + _toDisplayString(pagination.value.total) + " livraison(s) ", 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (changePage(pagination.value.page - 1))),
                disabled: pagination.value.page <= 1,
                class: "px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              }, " Précédent ", 8, _hoisted_24),
              _createElementVNode("span", _hoisted_25, " Page " + _toDisplayString(pagination.value.page) + " / " + _toDisplayString(pagination.value.totalPages), 1),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (changePage(pagination.value.page + 1))),
                disabled: pagination.value.page >= pagination.value.totalPages,
                class: "px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              }, " Suivant ", 8, _hoisted_26)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})